import { Pipe, PipeTransform } from '@angular/core';
import { CalenderData } from './calender/calender-data.model';

@Pipe({
  name: 'calenderFilterDaysByMonth',
  standalone: true,
})
export class CalenderFilterDaysPipe implements PipeTransform {
  transform(days: CalenderData[], month: number): CalenderData[] {
    // console.log('days',days.filter(d=>d.month==month))
    if (!month) return days;
    if (days &&!days[0]?.month) return days;
    return days?.filter((d) => d.month == month);
  }
}
